import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';

function News() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/api/news')
      .then(res => setItems(res.data))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="loading">A carregar...</div>;
  }

  return (
    <div className="container" style={{ paddingTop: '48px', paddingBottom: '72px' }}>
      <Link to="/" style={{ color: 'var(--text-secondary)', marginBottom: '24px', display: 'inline-block', fontSize: '0.88rem', letterSpacing: '0.03em' }}>
        ← Voltar ao início
      </Link>

      <h1 style={{ marginBottom: '12px', fontSize: '2.2rem' }}>Novidades</h1>
      <hr style={{ width: '50px', height: '2px', background: 'var(--accent)', border: 'none', marginBottom: '40px' }} />

      {items.length === 0 ? (
        <p style={{ color: 'var(--text-secondary)' }}>Sem novidades no momento. Volte em breve.</p>
      ) : (
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
          gap: '28px'
        }}>
          {items.map(item => (
            <article
              key={item.id}
              style={{
                background: 'var(--background-secondary)',
                borderRadius: 'var(--radius-lg, 14px)',
                overflow: 'hidden',
                border: '1px solid var(--border, rgba(255,255,255,0.06))',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease'
              }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.12)'; e.currentTarget.style.boxShadow = '0 16px 40px rgba(0,0,0,0.4)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.borderColor = ''; e.currentTarget.style.boxShadow = ''; }}
            >
              {item.image_url && (
                <div style={{ aspectRatio: '16/10', overflow: 'hidden' }}>
                  <img
                    src={item.image_url}
                    alt=""
                    style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.6s ease' }}
                    onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.04)'; }}
                    onMouseLeave={e => { e.currentTarget.style.transform = ''; }}
                  />
                </div>
              )}
              <div style={{ padding: '24px' }}>
                <h2 style={{ marginBottom: '12px', fontSize: '1.25rem', fontFamily: 'var(--font-heading)', fontWeight: 500 }}>{item.title}</h2>
                {item.body && (
                  <p
                    style={{
                      color: 'var(--text-secondary)',
                      lineHeight: '1.7',
                      fontSize: '0.92rem',
                      whiteSpace: 'pre-wrap',
                      display: '-webkit-box',
                      WebkitLineClamp: 4,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden'
                    }}
                  >
                    {item.body}
                  </p>
                )}
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}

export default News;
